export interface FormationCardTransform {
  readonly position: readonly [number, number, number];
  readonly rotationZ: number;
  readonly scale: number;
}

export interface FormationLayout {
  readonly commander: FormationCardTransform | null;
  readonly armies: readonly FormationCardTransform[];
}

export function adaptiveArmyScale(armyCount: number): number {
  const boundedCount = Math.max(0, Math.min(5, armyCount));
  if (boundedCount >= 5) return 0.92;
  if (boundedCount === 4) return 0.95;
  return 0.99;
}

function adaptiveArmySpacing(armyCount: number): number {
  if (armyCount >= 5) return 0.23;
  if (armyCount === 4) return 0.27;
  if (armyCount === 3) return 0.31;
  return 0.35;
}

export function getFormationLayout({
  owner,
  hasCommander,
  armyCount,
}: {
  readonly owner: "own" | "opponent";
  readonly hasCommander: boolean;
  readonly armyCount: number;
}): FormationLayout {
  const direction = owner === "own" ? 1 : -1;
  const boundedCount = Math.max(0, Math.min(5, armyCount));
  const armyScale = adaptiveArmyScale(boundedCount);
  const armySpacing = adaptiveArmySpacing(boundedCount);
  const armies = Array.from({ length: boundedCount }, (_, index) => {
    const center = (boundedCount - 1) / 2;
    const offset = index - center;
    return {
      position: [
        offset * armySpacing,
        0.045 + index * 0.012,
        direction * (0.16 + Math.abs(offset) * 0.012),
      ],
      rotationZ: offset * -0.07 * direction,
      scale: armyScale,
    } satisfies FormationCardTransform;
  });

  return {
    commander: hasCommander
      ? {
          position: [0, 0.16, direction * -0.14],
          rotationZ: owner === "own" ? 0 : Math.PI,
          scale: 1.18,
        }
      : null,
    armies,
  };
}
